import './../../style/dragDrop.css';
import {randomShuffle } from "./util"
import DragElementSmall from "./DragElementSmall"
import DropElementSmall from "./DropElementSmall"
import { useContext, useEffect, useState } from 'react';
import { isNeitherNullNorUndefined } from '../../utils/functions';
import {adjustListTags } from "../Page/utils/htmlAdjustments"


function DnDSmall({title, originalDrags, drops, correctAnswer, wrongAnswer}) {
    const [shuffledDragElements, setShuffledDragElements] = useState()
    const [currentlyClicked, setCurrentlyClicked] = useState()
    const [occupations, setOccupations] = useState([])
    const [drags, setDrags] = useState(originalDrags)
    const [finished, setFinished] = useState(false)
    const [success, setSuccess] = useState(false)
    const [dragElementsPosition, setDragElementsPosition] = useState(1)  // 0 = top, 1 = center, 2 = bottom

    function getCorrectIndex(dragItem){
        for(let i = 0; i < originalDrags.length; i++){
            if(dragItem === originalDrags[i]){
                return i
            } 
        }
        return 99   // TODO
    }



    useEffect(() => {
        console.log("originalDrags")
        console.log(originalDrags)

        setShuffledDragElements(randomShuffle(drags))
    }, [])

    useEffect(() => {
        // finished?
        if(occupations.length === originalDrags.length){
            setFinished(true)
        }
    }, [occupations])

    useEffect(() => {
        if(finished === true){
            let resultIsCorrect = true
            for(let i = 0; i < occupations.length; i++){
                resultIsCorrect = resultIsCorrect && occupations[i].dropPosition === occupations[i].correctPosition
            }
            resultIsCorrect ? setSuccess(true) : setSuccess(false)
        }
    }, [finished])

    useEffect(() => {
        console.log("currentlyClicked")
        console.log(currentlyClicked)

    }, [currentlyClicked])

    useEffect(() => {
        if(isNeitherNullNorUndefined(currentlyClicked)){
            setShuffledDragElements(drags.filter(d => {
                if(d !== currentlyClicked.dragElementContent){
                    return d
                }
            }))
        }
    }, [drags])







    function informAboutClick(correctIndex, dragElementContent){
        setCurrentlyClicked({
            correctIndex,
            dragElementContent
        })
    }

    function endClickOnDrag(){
        setCurrentlyClicked(null)
    }

 
    function resetDnD(){
        setOccupations([])
        setDrags(originalDrags)
        setSuccess(false)
        setFinished(false)
    }



    
    function informAboutOccupation(identifier){
        const newOccupation = {
            dropPosition: identifier,
            content: currentlyClicked.dragElementContent,
            correctPosition: currentlyClicked.correctIndex
        }
        setOccupations([...occupations, newOccupation])  
        const filterdDrags = drags.filter(d => {
            if(d !== currentlyClicked.dragElementContent){
                return d
            }
        })
        setDrags(filterdDrags)     
        setCurrentlyClicked(null) 
    }

    function checkOccupation(index){
        const result = occupations.filter(entry => {
            if(entry.dropPosition === index){
                return entry
            }
        })
        if(result && result.length > 0){
            return result[0]
        }else {
            return null
        }
    }





    // up and down buttons on small screen
    function moveDragElementsUp(){
        if(dragElementsPosition === 1){
            setDragElementsPosition(0)
        } else if(dragElementsPosition === 2){
            setDragElementsPosition(1)
        }
    }
    function moveDragElementsDown(){
        if(dragElementsPosition === 0){
            setDragElementsPosition(1)
        } else if(dragElementsPosition === 1){
            setDragElementsPosition(2)
        }
    }
    function checkVisibility(position){
        if(position === "upper"){
            if(dragElementsPosition === 0){
                return " dndDragScrollIconInvisible "
            } else {
                return " dndDragScrollIconVisible "
            }
        } else if(position === "lower"){
            if(dragElementsPosition === 2){
                return " dndDragScrollIconInvisible "
            } else {
                return " dndDragScrollIconVisible "
            }
        }
    }

  

    

    





    return (
        <div className='flex flex-col justify-center'>
            <div className={"dragDropContainer " + (finished && success ? "dndSuccess " : finished && !success && "dndFail")}>
            <div className='self-center'>{title}</div>
            <div className="innerDndContainer ">
                <div className={"mr-3 " + "dragElementsPosition" + dragElementsPosition}>
                    <svg className={"dndDragScrollIcon w-6 h-6 text-gray-800 dark:text-white " + checkVisibility("upper")}
                        aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 12"
                        onClick={moveDragElementsUp}
                    >
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5m8 6L5 7l-4 4"/>
                    </svg>

                    {drags.map((drag, index) => {
                        return <DragElementSmall correctIndex={getCorrectIndex(drag)} 
                                    content={drag} 
                                    informAboutClick={informAboutClick} 
                                    endClickOnDrag={endClickOnDrag}
                                    isClicked={currentlyClicked?.correctIndex === getCorrectIndex(drag)}
                                />
                    })}

                    <svg className={"dndDragScrollIcon mt-2 w-6 h-6 text-gray-800 dark:text-white " + checkVisibility("lower")}
                        aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 12"
                        onClick={moveDragElementsDown}
                    >
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 7 4 4 4-4M1 1l4 4 4-4"/>
                    </svg>
                </div>


                <div className="ml-3 itemsContainer">
                {drops.map((drop, index) => {
                    return <DropElementSmall content={drop} 
                                        identifier={index} 
                                        currentlyClicked={currentlyClicked} 
                                        informAboutOccupation={informAboutOccupation}
                                        occupied={occupations ? checkOccupation(index) : null}  
                                        readyToReceive={currentlyClicked && !checkOccupation(index)}
                                        /> 
                    })}
                </div>
            </div>
                
            
                {finished &&
                <div className='self-center mb-2'>{
                    success 
                    ?
                    <div className="droppedElement "
                        dangerouslySetInnerHTML={{__html: adjustListTags(correctAnswer)}}
                    />
                    :
                    <div className="droppedElement "
                        dangerouslySetInnerHTML={{__html: adjustListTags(wrongAnswer)}}  
                    />     
                    }
                </div>
                }
                
                <div className="self-center " >
                    <button className="btn resetButton " onClick={resetDnD}>
                        <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 20">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 1v5h-5M2 19v-5h5m10-4a8 8 0 0 1-14.947 3.97M1 10a8 8 0 0 1 14.947-3.97"/>
                        </svg>
                        <div className='ml-1'>Reset</div>
                    </button>
                </div>
            </div>
        </div>

                
    )
}

export default DnDSmall